import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { dbx } from "src/utils/urlBack_End";
import { useSnackbar } from "notistack";
import saveFill from "@iconify/icons-eva/save-outline";
import { useAdjuntarArchivoTareaMutation } from "../../services/accesoClientesApi";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/HighlightOff";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card,
  Grid,
  Alert,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LoadingButton } from "@material-ui/lab";

const styles = makeStyles(() => ({
  formControl: {
    minWidth: "100%",
    marginBottom: 7,
    marginTop: 12,
  },
  gridContainer: {},
  Container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 15,
  },
  textField: {
    width: "100%",
    marginBottom: 18,
    marginTop: 15,
  },
  textFieldComentario: {
    marginBottom: 18,
    marginTop: 20,
  },
  hidden: {
    display: "none",
  },
}));

export default function AdjuntarDocumento(props) {
  const { open, setOpen, tarea } = props;
  const { enqueueSnackbar } = useSnackbar();
  const classes = styles();
  const [file, setFile] = useState(null);

  // RTK Query Mutation
  const [adjuntarArchivo, { isLoading: isSubmitting }] =
    useAdjuntarArchivoTareaMutation();

  const handleClose = () => {
    setOpen(false);
  };

  const guardarDatos = async () => {
    if (file !== null) {
      await uploadFile("Tareas");
    } else {
      enqueueSnackbar("Debe seleccionar un archivo", { variant: "warning" });
    }
  };

  const cerrar = () => {
    handleClose();
  };

  const handleFileInput = (e) => {
    const fileAux = e.target.files[0];
    if (fileAux === undefined) {
      return;
    }
    setFile(fileAux);
  };

  const handleDeleteFile = () => {
    setFile(null);
  };

  async function uploadFile(ruta) {
    if (!file) return false;

    const UPLOAD_FILE_SIZE_LIMIT = 150 * 1024 * 1024;

    if (file.size >= UPLOAD_FILE_SIZE_LIMIT) {
      enqueueSnackbar("El archivo supera el límite de 150MB", {
        variant: "error",
      });
      return false;
    }

    try {
      // 1. Subir archivo a Dropbox
      await dbx.filesUpload({
        path: `/${ruta}/${tarea.id}/` + file.name,
        contents: file,
        mode: "overwrite",
      });

      // 2. Obtener link compartido de Dropbox
      try {
        const shareResponse = await dbx.sharingCreateSharedLinkWithSettings({
          path: `/${ruta}/${tarea.id}/` + file.name,
        });

        const url = shareResponse.result.url;

        // 3. Registrar metadata en el backend
        try {
          await adjuntarArchivo({
            idTarea: tarea.id,
            nombreArchivo: file.name,
            tipoArchivo: file.type,
            link: url,
          }).unwrap();

          // Éxito
          setFile(null);
          setOpen(false);
          enqueueSnackbar("Archivo subido correctamente", {
            variant: "success",
          });
        } catch (backendError) {
          console.error("Error al registrar archivo en backend:", backendError);
          enqueueSnackbar("Error al registrar el archivo en el sistema", {
            variant: "error",
          });
        }
      } catch (dropboxShareError) {
        // El archivo ya existe en Dropbox
        console.error("Error al crear link compartido:", dropboxShareError);

        if (dropboxShareError.error?.error?.shared_link_already_exists) {
          enqueueSnackbar("El archivo ya existe en el sistema", {
            variant: "warning",
          });
        } else {
          enqueueSnackbar("Error al compartir el archivo en Dropbox", {
            variant: "error",
          });
        }
      }
    } catch (uploadError) {
      console.error("Error al subir archivo a Dropbox:", uploadError);
      enqueueSnackbar("Error al subir el archivo a Dropbox", {
        variant: "error",
      });
      return false;
    }
  }

  return (
    <>
      <div>
        <Dialog open={open} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Subir Archivo</DialogTitle>
          <DialogContent>
            <Card style={{ padding: "1rem" }}>
              <Alert severity="info">
                Haga click en el botón 'Seleccionar Archivo' para subir un
                documento.
              </Alert>

              <Grid container style={{ marginTop: "10px" }}>
                <Grid item xs={4} md={4}>
                  <input
                    className={classes.hidden}
                    id="contained-button-file"
                    onChange={handleFileInput}
                    type="file"
                  />

                  <label htmlFor={"contained-button-file"}>
                    <Button
                      fullWidth
                      component="span"
                      m={1}
                      variant="contained"
                    >
                      Seleccionar Archivo
                    </Button>
                  </label>
                </Grid>
                <Grid item xs={6} md={6}>
                  {file && (
                    <span>
                      <span>
                        <> {file.name}</>
                      </span>

                      <span>
                        <IconButton
                          onClick={handleDeleteFile}
                          aria-label="delete"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </span>
                    </span>
                  )}
                </Grid>
              </Grid>
            </Card>

            <DialogActions>
              <LoadingButton onClick={() => cerrar()} color="error">
                Cancelar
              </LoadingButton>
              <LoadingButton
                type="submit"
                color="primary"
                startIcon={<Icon icon={saveFill} />}
                loading={isSubmitting}
                onClick={guardarDatos}
              >
                Guardar Cambios
              </LoadingButton>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
